// Completed by
export const CompletedBy = "CompletedBy";
export const CompletedByName = "CompletedByName";
export const CompletedByTitle = "CompletedByTitle";
export const CompletedByQualification = "CompletedByQualification";

// Completed on Behalf of
export const CompletedOnBehalfOf = "CompletedOnBehalfOf";
export const CompletedOnBehalfOfName = "CompletedOnBehalfOfName";
export const CompletedOnBehalfOfTitle = "CompletedOnBehalfOfTitle";
export const CompletedOnBehalfOfQualification = "CompletedOnBehalfOfQualification";

// Introduction and Data Privacy
export const IntroductionAndDataPrivacyConfirmDOB = "IntroductionAndDataPrivacyConfirmDOB";
export const IntroductionAndDataPrivacyConfirmAddress = "IntroductionAndDataPrivacyConfirmAddress";
export const IntroductionAndDataPrivacyConfirmOtherIdentifier = "IntroductionAndDataPrivacyConfirmOtherIdentifier";
export const IntroductionAndDataPrivacyConfirmOtherIdentifierDetails = "IntroductionAndDataPrivacyConfirmOtherIdentifierDetails";
export const IntroductionAndDataPrivacyConsultationMethod = "IntroductionAndDataPrivacyConsultationMethod";
export const IntroductionAndDataPrivacyRecordingConsent = "IntroductionAndDataPrivacyRecordingConsent";
export const IntroductionAndDataPrivacyProceedConsent = "IntroductionAndDataPrivacyProceedConsent";

// Questionnaires and Risk
export const PsychologicalWellbeingPHQ9Score = "PsychologicalWellbeingPHQ9Score";
export const PsychologicalWellbeingPHQ9Outcome = "PsychologicalWellbeingPHQ9Outcome";
export const PsychologicalWellbeingGAD7Score = "PsychologicalWellbeingGAD7Score";
export const PsychologicalWellbeingGAD7Outcome = "PsychologicalWellbeingGAD7Outcome";
export const PsychologicalWellbeingWSASScore = "PsychologicalWellbeingWSASScore";
export const PsychologicalWellbeingWSASOutcome = "PsychologicalWellbeingWSASOutcome";

export const RiskAssessmentCompleted = "RiskAssessmentCompleted";
export const RiskAssessmentCompletedToSelf = "RiskAssessmentCompletedToSelf";
export const RiskAssessmentCompletedToOthers = "RiskAssessmentCompletedToOthers";
export const RiskAssessmentCompletedSafeguardingIssues = "RiskAssessmentCompletedSafeguardingIssues";
export const RiskAssessmentCompletedFactorsAddingToRisk = "RiskAssessmentCompletedFactorsAddingToRisk";
export const RiskManagementPlan = "RiskManagementPlan";

// IAPT Questionnaire
// - General Questions
export const IaptCarryOutIaptAssessment = "IaptCarryOutIaptAssessment";
export const IaptEmployeeName = "IaptEmployeeName";
export const IaptJobRole = "IaptJobRole";
export const IaptCarryOutPhq9Assessment = "IaptCarryOutPhq9Assessment";
export const IaptCarryOutGad7Assessment = "IaptCarryOutGad7Assessment";
export const IaptCarryOutWsasAssessment = "IaptCarryOutWsasAssessment";

export const isIAPTGeneralQuestionsQuestion = (questionId: string) => {
    return [
        IaptCarryOutIaptAssessment,
        IaptEmployeeName,
        IaptJobRole,
        IaptCarryOutPhq9Assessment,
        IaptCarryOutGad7Assessment,
        IaptCarryOutWsasAssessment
    ].includes(questionId);
};

// - PHQ9 questionIds
export const IaptLittleInterestOrPleasureInDoingThings = "IaptLittleInterestOrPleasureInDoingThings";
export const IaptFeelingDownDepressedOrHopeless = "IaptFeelingDownDepressedOrHopeless";
export const IaptTroubleFallingOrStayingAsleepOrSleepingTooMuch = "IaptTroubleFallingOrStayingAsleepOrSleepingTooMuch";
export const IaptFeelingTiredOrHavingLittleEnergy = "IaptFeelingTiredOrHavingLittleEnergy";
export const IaptPoorAppetiteOrOvereating = "IaptPoorAppetiteOrOvereating";
export const IaptFeelingBadAboutYourself = "IaptFeelingBadAboutYourself";
export const IaptTroubleConcentratingOnReadingOrWatching = "IaptTroubleConcentratingOnReadingOrWatching";
export const IaptMovingOrSpeakingSoSlowly = "IaptMovingOrSpeakingSoSlowly";
export const IaptThoughtsThatWouldBeBetterOffDeadOrOfHurtingYourself = "IaptThoughtsThatWouldBeBetterOffDeadOrOfHurtingYourself";
export const IaptPsychologicalWellbeingPHQ9Score = "IaptPsychologicalWellbeingPHQ9Score";

export const isPHQ9Question = (questionId: string) => {
    return [
        IaptLittleInterestOrPleasureInDoingThings,
        IaptFeelingDownDepressedOrHopeless,
        IaptTroubleFallingOrStayingAsleepOrSleepingTooMuch,
        IaptFeelingTiredOrHavingLittleEnergy,
        IaptPoorAppetiteOrOvereating,
        IaptFeelingBadAboutYourself,
        IaptTroubleConcentratingOnReadingOrWatching,
        IaptMovingOrSpeakingSoSlowly,
        IaptThoughtsThatWouldBeBetterOffDeadOrOfHurtingYourself
    ].includes(questionId);
};

// - GAD7 questionIds
export const IaptFeelingNervousAnxiousOrOnEdge = "IaptFeelingNervousAnxiousOrOnEdge";
export const IaptNotBeingAbleToStopOrControlWorrying = "IaptNotBeingAbleToStopOrControlWorrying";
export const IaptWorryingTooMuchAboutDifferentThings = "IaptWorryingTooMuchAboutDifferentThings";
export const IaptTroubleRelaxing = "IaptTroubleRelaxing";
export const IaptBeingSoRestlessThatItIsHardToSitStill = "IaptBeingSoRestlessThatItIsHardToSitStill";
export const IaptBecomingEasilyAnnoyedOrIrritable = "IaptBecomingEasilyAnnoyedOrIrritable";
export const IaptFeelingAfraidAsIfSomethingAwfulMightHappen = "IaptFeelingAfraidAsIfSomethingAwfulMightHappen";
export const IaptPsychologicalWellbeingGAD7Score = "IaptPsychologicalWellbeingGAD7Score";

export const isGAD7Question = (questionId: string) => {
    return [
        IaptFeelingNervousAnxiousOrOnEdge,
        IaptNotBeingAbleToStopOrControlWorrying,
        IaptWorryingTooMuchAboutDifferentThings,
        IaptTroubleRelaxing,
        IaptBeingSoRestlessThatItIsHardToSitStill,
        IaptBecomingEasilyAnnoyedOrIrritable,
        IaptFeelingAfraidAsIfSomethingAwfulMightHappen
    ].includes(questionId);
};

// - WSAS questionIds
export const IaptWork = "IaptWork";
export const IaptHomeManagement = "IaptHomeManagement";
export const IaptSocialLeisureActivities = "IaptSocialLeisureActivities";
export const IaptPrivateLeisureActivities = "IaptPrivateLeisureActivities";
export const IaptFamilyAndRelationships = "IaptFamilyAndRelationships";
export const IaptPsychologicalWellbeingWSASScore = "IaptPsychologicalWellbeingWSASScore";

export const isWSASQuestion = (questionId: string) => {
    return [
        IaptWork,
        IaptHomeManagement,
        IaptSocialLeisureActivities,
        IaptPrivateLeisureActivities,
        IaptFamilyAndRelationships
    ].includes(questionId);
};

// Clinical Notes
export const ClinicalNotesRiskLetterToGeneralPractitioner = "ClinicalNotesRiskLetterToGeneralPractitioner";
export const ClinicalNotesComments = "ClinicalNotesComments";

// Standard Clinical Details and Outcome
export const ClinicalDetailsCurrentWorkStatus = "ClinicalDetailsCurrentWorkStatus";
export const ClinicalDetailsProvisionalDiagnosis = "ClinicalDetailsProvisionalDiagnosis";
export const ClinicalDetailsCoMorbidConditions = "ClinicalDetailsCoMorbidConditions";
export const ClinicalDetailsCoMorbidConditionsOther = "ClinicalDetailsCoMorbidConditionsOther";
export const ClinicalDetailsTreatmentCompletedInTodaysSession = "ClinicalDetailsTreatmentCompletedInTodaysSession";
export const ClinicalDetailsTreatmentCompletedInTodaysSessionOther = "ClinicalDetailsTreatmentCompletedInTodaysSessionOther";
export const ClinicalDetailsSessionsSignpostingDischarge = "ClinicalDetailsSessionsSignpostingDischarge";
export const ClinicalDetailsSignpostToOtherServices = "ClinicalDetailsSignpostToOtherServices";
export const ClinicalDetailsSignpostToOtherServicesOther = "ClinicalDetailsSignpostToOtherServicesOther";
export const ClinicalDetailsOutcomeFinalSessionOnly = "ClinicalDetailsOutcomeFinalSessionOnly";
export const ClinicalDetailsOnwardReferral = "ClinicalDetailsOnwardReferral";

// Consent and Report
export const ConsentAndReportConsent = "ConsentAndReportConsent";
export const ConsentAndReportScopeOfReport = "ConsentAndReportScopeOfReport";
export const ConsentAndReportAlternativeConsentChoice = "ConsentAndReportAlternativeConsentChoice";
export const EmployeeEmailAddress = "EmployeeEmailAddress";
export const ManagerEmailAddress = "ManagerEmailAddress";
export const HREmailAddress = "HREmailAddress";
